import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
  GPX_FEATURES,
  GPX_PARTNERS,
} from '@rsos/gainsight';

// Event names specific emergency call tracking
const EVENT_NAMES = {
  RCS_TOAST_CLOSE: 'close_rcs_toast',
  RCS_TOAST_VIEW: 'view_rcs_toast',
  RCS_TIMEOUT: 'rcs_timeout',
};

/**
 * Tracks when a user closes an RCS toast
 * @param {Object} params
 * @param {string} params.conversationId - The unique identifier for the RCS conversation
 * @param {string} params.sessionId - The unique identifier for the session
 */
export const trackCloseRCSToast = ({ conversationId, sessionId }) => {
  gspx.trackEvent({
    name: EVENT_NAMES.RCS_TOAST_CLOSE,
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.RCS911,
    capability: GPX_CAPABILITIES.TT911,
    route: GPX_ROUTES.COMMUNICATOR,
    partner: GPX_PARTNERS.GOOGLE,
    entities: {
      conversation_id: conversationId,
      session_id: sessionId,
    },
  });
};

/**
 * Tracks when a user views an RCS toast
 * @param {Object} params
 * @param {string} params.conversationId - The unique identifier for the RCS conversation
 * @param {string} params.sessionId - The unique identifier for the session
 */
export const trackViewRCSToast = ({ conversationId, sessionId }) => {
  gspx.trackEvent({
    name: EVENT_NAMES.RCS_TOAST_VIEW,
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.RCS911,
    capability: GPX_CAPABILITIES.TT911,
    route: GPX_ROUTES.COMMUNICATOR,
    partner: GPX_PARTNERS.GOOGLE,
    entities: {
      conversation_id: conversationId,
      session_id: sessionId,
    },
  });
};

/**
 * Tracks when a RCS session times out
 * @param {Object} params
 * @param {string} params.conversationId - The unique identifier for the RCS conversation
 * @param {string} params.sessionId - The unique identifier for the session
 */
export const trackRcsTimeout = ({ conversationId, sessionId }) => {
  gspx.trackEvent({
    name: EVENT_NAMES.RCS_TIMEOUT,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.RCS911,
    capability: GPX_CAPABILITIES.TT911,
    route: GPX_ROUTES.COMMUNICATOR,
    partner: GPX_PARTNERS.GOOGLE,
    entities: {
      conversation_id: conversationId,
      session_id: sessionId,
    },
  });
};
